import { FormElement } from '../types/serialized-types';
import { BotElement } from '../types/model-types';


@BotElement.register("fillin-list")
class FillinList extends BotElement {
    varName: string = "";

    static fromJSON(obj: FormElement): FillinList {
        let fil = new FillinList(obj.type);
        fil.id = obj.id || null;
        fil.varName = obj["var-name"];
        return fil;
    }

    shouldStop(context: object) {
        return true;
    }
}


export {
    FillinList
}
